module.exports = __webpack_public_path__ + "img/bar_logo@2x.eccde8f2.png";